// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:TagList'); // eslint-disable-line no-unused-vars
import { ThemeType } from 'trustar-2.0/types';

const initialValues = {
};

// Bindings
type TagListProps = {
  theme?: ThemeType,
};

const StyledTagList = styled.ul`
  padding: 0;
  margin-top: 0;
  overflow-y: auto;
`;

const TagList = ({
  ...otherProps
}: TagListProps) => {

  return <StyledTagList {...otherProps} />;
}

export { TagList };



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Tags/TagList.js